import { render, staticRenderFns } from "./Volunteer.view.vue?vue&type=template&id=2ed7f552&"
import script from "./Volunteer.view.vue?vue&type=script&lang=js&"
export * from "./Volunteer.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports